<template>
  <v-container>
    <v-row class="hidden-lg-and-up">
      <v-col
        cols="12"
      >
        <project-logo
          :in-card="true"
          :light-logo="projectLogoHorizontalLight"
          :dark-logo="projectLogoHorizontalDark"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="(card, index) in cards"
        :key="index"
        cols="12"
        :md="cards.length === 1 ? 12 : 6"
        :xl="cards.length === 1 ? 12 : cards.length === 2 ? 6 : 4"
      >
        <Card
          :key="card.title"
          :title="$t(card.title)"
          :eservice="card.eservice"
          :text="$t(card.text)"
          :image="card.image"
          :url="card.url"
          :to="card.to"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
        xl="4"
      >
        <!-- TODO Mapa powinna się wczytywać z TERYTU -->
        <Map
          :description="$t('home.projectDescription')"
          :title="$t('home.system')"
          :svg="`${publicPath}api/mapHome.json`"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        xl="4"
      >
        <list-county
          :title="$t('home.partners')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        xl="4"
      >
        <v-card
          outlined
          class="mx-auto"
        >
          <v-card-text>
            <div
              class="mb-2"
            >
              <p>
                {{ $t('home.legal1') }}
              </p>

              <p>
                {{ $t('home.legal2') }}
              </p>

              <p>
                {{ $t('home.legal3') }}
              </p>
            </div>
          </v-card-text>
          <v-snackbar
            v-model="snackbar"
            :vertical="$vuetify.breakpoint.xsOnly"
            :timeout="0"
            right
          >
            <b>
              {{ $t('home.alertText') }}
            </b>
            <v-btn
              color="primary"
              text
              @click="snackbar = false"
            >
              {{ $t('home.alertClose') }}
            </v-btn>
          </v-snackbar>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// @ is an alias to /src
import axios from 'axios'
import { mapState } from 'vuex'
export default {
  name: 'Home',
  components: {
    ProjectLogo: () => import('@/components/Utility/ProjectLogo.vue'),
    Card: () => import('@/components/Card'),
    Map: () => import('@/components/Map/Map'),
    ListCounty: () => import('@/components/ListCounty/ListCounty')
  },
  data: () => ({
    publicPath: process.env.BASE_URL,
    snackbar: true,
    cards: undefined
  }),
  computed: {
    ...mapState('settings', {
      projectLogoHorizontalLight: state => state.projectLogoHorizontalLight,
      projectLogoHorizontalDark: state => state.projectLogoHorizontalDark
    })
  },
  created () {
    axios
      .get(`${this.publicPath}api/cardsHome.json`)
      .then(response => (this.cards = response.data))
  }
}
</script>
